let STATUS_TO_VIEW_MAP = {
  processed: 'SyncPatients',
  error: 'Error',
  matching: 'Matching',
  processing: 'Syncing',
  completed: 'Completed',
}

export function getView(status, is_matching) {
  if (status === 'processed' && is_matching === true) {
    return STATUS_TO_VIEW_MAP.completed
  }
  return STATUS_TO_VIEW_MAP[status] || 'Syncing'
}
